import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  CollectorListItem,
  CollectorsConfig
} from '../../../domain/collector-profile.model';

@Component({
  selector: 'app-collector-event-combinations-card',
  templateUrl: './collector-event-combinations-card.component.html',
  styleUrls: [
    '../collector-card.shared.css',
    './collector-event-combinations-card.component.css'
  ]
})
export class CollectorEventCombinationsCardComponent {
  @Input() collector!: CollectorListItem;
  @Input() config!: CollectorsConfig;
  @Input() readOnly = false;
  @Output() change = new EventEmitter<void>();

  emitChange(): void {
    if (!this.readOnly) {
      this.change.emit();
    }
  }
}
